import axios from 'axios'
import { apiAccessOAZalo, secretKeyZalo } from '../config/env'
let headers = {
   "Content-Type": "application/x-www-form-urlencoded",
    'secret_key':secretKeyZalo,
    //'content-type': 'multipart/form-data',
}
const axiosIntanceAccesZalo = axios.create({
    baseURL: apiAccessOAZalo,
    headers: headers
})
axiosIntanceAccesZalo.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosIntanceAccesZalo.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosIntanceAccesZalo